var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M1.5 1.5H6.5V6.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M6,2v4H2V2H6 M7,1H1v6h6V1L7,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M9.5 9.5H14.5V14.5H9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M14,10v4h-4v-4H14 M15,9H9v6h6V9L15,9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M1.5 9.5H6.5V14.5H1.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M6,10v4H2v-4H6 M7,9H1v6h6V9L7,9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M2.586 10.586H5.414V13.414H2.586z",
    transform: "rotate(-45.001 4 12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M2.5 10.5H5.5V13.5H2.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M4.828 3.97L4 4.738 5.139 6 6 6 6 5.061z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 2A0.5 0.5 0 1 0 5.5 3A0.5 0.5 0 1 0 5.5 2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e09367",
    d: "M5.385 6L2 6 2 5 3.333 3.667z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12l-.583-.971C11.146 10.576 11.472 10 12 10h0c.528 0 .854.576.583 1.029L12 12zM12 12l.583.971C12.854 13.424 12.528 14 12 14h0c-.528 0-.854-.576-.583-1.029L12 12z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12l-1.132.019c-.528.009-.864-.562-.6-1.019l0 0c.264-.457.926-.452 1.182.01L12 12zM12 12l1.132-.019c.528-.009.864.562.6 1.019l0 0c-.264.457-.926.452-1.182-.01L12 12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12l-.55.99c-.256.462-.918.467-1.182.01l0 0c-.264-.457.072-1.028.6-1.019L12 12zM12 12l.55-.99c.256-.462.918-.467 1.182-.01l0 0c.264.457-.072 1.028-.6 1.019L12 12z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M12 11A1 1 0 1 0 12 13A1 1 0 1 0 12 11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 11A1 1 0 1 0 4 13A1 1 0 1 0 4 11Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M9.5 1.5H14.5V6.5H9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M14,2v4h-4V2H14 M15,1H9v6h6V1L15,1z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.9,3.8c-0.014,0-0.026,0.007-0.04,0.008c-0.074-0.174-0.247-0.296-0.448-0.296 c-0.061,0-0.119,0.014-0.173,0.035C12.144,3.343,11.94,3.2,11.7,3.2c-0.331,0-0.6,0.269-0.6,0.6c-0.331,0-0.6,0.269-0.6,0.6 c0,0.331,0.269,0.6,0.6,0.6c0.331,0,1.492,0,1.8,0c0.331,0,0.6-0.269,0.6-0.6C13.5,4.069,13.231,3.8,12.9,3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.fec66ad66fb36788e428cac092d4672f.svg";
export { ForwardRef as ReactComponent };